module.exports = __webpack_public_path__ + "static/media/fidweb-practicle-stress_optimized.4034a03a.png";